import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { useSmartSkeleton } from '@/hooks/useSmartSkeleton';
import { FullPageLoader } from './FullPageLoader';

export default function PublicOnlyRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const showLoader = useSmartSkeleton(isLoading);

  if (showLoader) {
    return <FullPageLoader />;
  }

  if (isAuthenticated) {
    // If the user is logged in, redirect them to the dashboard.
    return <Navigate to="/" replace />;
  }

  // If the user is not logged in, show the requested public page (e.g., Login).
  return <Outlet />;
}
